import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgPipesModule } from 'ngx-pipes';
import { NgbModule, NgbModalModule, NgbPaginationModule, NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

import { SelectPeriodComponent } from './select-period/select-period.component';
import { SelectAreaComponent } from './select-area/select-area.component';
import { SelectPeriodAreaComponent } from './select-period-area/select-period-area.component';
import { PeriodDropdownComponent } from './select-period-area/period-dropdown/period-dropdown.component';
import { AreaDropdownComponent } from './select-period-area/area-dropdown/area-dropdown.component';
import { MobileNavComponent } from './mobile-nav/mobile-nav.component';
import { SelectIndicatorComponent } from './select-indicator/select-indicator.component';
import { IndicatorMetadataComponent } from './indicator-metadata/indicator-metadata.component';
import { DownloadLinkComponent } from './download-link/download-link.component';
import { DownloadLinkListComponent } from './download-link-list/download-link-list.component';
import { UserGuideComponent } from './user-guide/user-guide.component';
import { ChartDownloaderComponent } from './chart-downloader/chart-downloader.component';
import { BackDropComponent } from './back-drop/back-drop.component';
import { ExtractTableComponent } from './extract-table/extract-table.component';
import { SuppressedValueFlagComponent } from './suppressed-value-flag/suppressed-value-flag.component';
import { ClickElsewhereDirective } from './clickElsewhereDirective';
import { HighlightPipe } from '../_pipes/highlight.pipe';

const SHARED_DECLARATIONS = [
  SelectPeriodComponent,
  SelectAreaComponent,
  SelectPeriodAreaComponent,
  PeriodDropdownComponent,
  AreaDropdownComponent,
  MobileNavComponent,
  SelectIndicatorComponent,
  IndicatorMetadataComponent,
  DownloadLinkComponent,
  DownloadLinkListComponent,
  UserGuideComponent,
  ChartDownloaderComponent,
  BackDropComponent,
  ExtractTableComponent,
  SuppressedValueFlagComponent,
  ClickElsewhereDirective,
  HighlightPipe,
];

// Third-party modules the shared components and every feature template rely on.
// Re-exported so a lazy feature module only has to import SharedModule to get the
// same set of directives it used to get from AppModule.
const SHARED_IMPORTS = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  NgPipesModule,
  NgbModule,
  NgbModalModule,
  NgbPaginationModule,
  NgbAlertModule,
  NgxSliderModule,
];

@NgModule({
  declarations: SHARED_DECLARATIONS,
  imports: SHARED_IMPORTS,
  exports: [...SHARED_DECLARATIONS, ...SHARED_IMPORTS],
})
export class SharedModule { }
